import React from "react";

const logoSrc = require("./../images/logo.png");

const Logo = () => (
  <div className="logo">
    <img src={logoSrc.default} alt="Trinity Health Logo" />
  </div>
);

export default Logo;
